import React from "react";
import {
  Paper,
  Grid2 as Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  useTheme,
} from "@mui/material";
import { FilterOptions } from "./types";
import { DatePicker } from "@mui/x-date-pickers";

interface FilterSectionProps {
  filters: FilterOptions;
  uniqueAssignees: { id: number | null; name: string }[];
  uniqueSegments: string[]; // Ny prop för unika kundkategorier
  handleDateChange: (
    field: keyof FilterOptions
  ) => (newValue: Date | null) => void;
  handleSortChange: (event: SelectChangeEvent) => void;
  handleAssigneeChange: (event: SelectChangeEvent) => void;
  handleSegmentChange: (event: SelectChangeEvent) => void; // Ny handler
}

const FilterSection: React.FC<FilterSectionProps> = ({
  filters,
  uniqueAssignees,
  uniqueSegments,
  handleDateChange,
  handleSortChange,
  handleAssigneeChange,
  handleSegmentChange,
}) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mx: 2,
        mb: 2,
        bgcolor: theme.palette.grey[50],
        borderRadius: 1,
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
          <DatePicker
            label="Från datum"
            value={filters.startDate}
            onChange={handleDateChange("startDate")}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
          <DatePicker
            label="Till datum"
            value={filters.endDate}
            onChange={handleDateChange("endDate")}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
          <FormControl fullWidth size="small">
            <InputLabel shrink>Ansvarig</InputLabel>
            <Select
              value={filters.assignedTo}
              onChange={handleAssigneeChange}
              label="Ansvarig"
              displayEmpty
            >
              <MenuItem value="">Alla användare</MenuItem>
              {uniqueAssignees.map((assignee) => (
                <MenuItem key={assignee.id} value={assignee.name}>
                  {assignee.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
          <FormControl fullWidth size="small">
            <InputLabel shrink>Kundkategori</InputLabel>
            <Select
              value={filters.customerSegment}
              onChange={handleSegmentChange}
              label="Kundkategori"
              displayEmpty
            >
              <MenuItem value="">Alla kategorier</MenuItem>
              {uniqueSegments.map((segment) => (
                <MenuItem key={segment} value={segment}>
                  {segment}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
          <FormControl fullWidth size="small">
            <InputLabel>Sortera efter</InputLabel>
            <Select
              value={filters.sortBy}
              onChange={handleSortChange}
              label="Sortera efter"
            >
              <MenuItem value="newest">Nyast först</MenuItem>
              <MenuItem value="oldest">Äldst först</MenuItem>
              <MenuItem value="value-high">Högst värde först</MenuItem>
              <MenuItem value="value-low">Lägst värde först</MenuItem>
              <MenuItem value="probability-high">
                Högst sannolikhet först
              </MenuItem>
              <MenuItem value="probability-low">
                Lägst sannolikhet först
              </MenuItem>
              <MenuItem value="name-asc">Namn (A-Ö)</MenuItem>
              <MenuItem value="name-desc">Namn (Ö-A)</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FilterSection;
